<div *ngIf="!isLoading && totalRecords === 0" [ngClass]="class">
    <div class="text-center card-body m-4">
        <i class="fe fe-alert-circle fs-1"></i>
        <h2 class="m-2">{{ 'NoResultsTitle' | translate }}</h2>
        <p class="text-muted fs-5 m-0">{{ 'NoResultsMessage' | translate }}</p>
    </div>
</div>